import { bindable } from 'aurelia-templating';
import { autoinject } from 'aurelia-dependency-injection';
import "jquery.qrcode";

@autoinject()
export class QrViewerPrint {

    @bindable()
    source: string;
    @bindable()
    height: number | string;
    @bindable()
    width: number | string;
    @bindable()
    imgQrSrc: string;
    @bindable()
    stylesHref: string = "/styles/core.css";
    @bindable()
    logoSrc: string;
    @bindable()
    title: string;

    qrcode: any;
    printableDiv: any;

    sourceChanged() {
        if (this.qrcode && this.source) {
            this.ensureDimensionsSet();
            $(this.qrcode)["qrcode"]({ text: this.source });

            const canvas = $(this.qrcode).find('canvas').get(0);
            this.imgQrSrc = this.convertCanvasToImage(canvas);
        }
    }

    attached() {
        this.sourceChanged();
    }

    private ensureDimensionsSet() {
        if (!this.width) {
            this.width = 64;
        }
        if (!this.height) {
            this.height = 64;
        }
    }

    iOSVersion() {
        if ((<any>window).MSStream) {
            // There is some iOS in Windows Phone...
            // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
            return false;
        }
        const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        let version;

        if (match !== undefined && match !== null) {
            version = [
                parseInt(match[1], 10),
                parseInt(match[2], 10),
                parseInt(match[3] || "0", 10)
            ];
            return parseFloat(version.join("."));
        }

        return false;
    }

    private get htmlBuilded() {
        return `<html>
            <head>
                <title>Print Event Details</title>
                <link href="${this.stylesHref}" rel="stylesheet" type="text/css">
                <script>
                    function hideLoading()
                    {
                        setTimeout(() =>
                            {
                                let element =  document.getElementById("loadingDiv");

                                document.getElementById("loadingDiv").style = "display: none";
                                document.getElementById("loadingDiv").style.display = 'none';
                                document.getElementById("printableDiv").style.visibility = "visible";
                                document.getElementById("printableDiv").style = "";

                                window.focus(); // necessary for IE >= 10
                                window.print();

                                let timeout = 0;
                                if(${this.iOSVersion()})
                                    timeout = 2000;

                                setTimeout(() => {
                                    window.close();
                                }, timeout);
                            }, 2000);
                    }
                </script>
            </head>
            <body onload="hideLoading()">

                <!--Main Page Loading-->
                <div class="app-loading" id="loadingDiv">
                    <div class="loading-container">
                        <img src="/src/images/branding/logo-bidin-green.svg" height="80">
                        <div class="loader-images">
                            <div class="paddle-container paddle-container-one">
                                <i class="loader-paddle"></i>
                            </div>

                            <div class="paddle-container paddle-container-two">
                                <i class="loader-paddle"></i>
                            </div>

                            <div class="paddle-container paddle-container-three">
                                <i class="loader-paddle"></i>
                            </div>
                        </div>
                    </div>
                </div>

                ${this.printableDiv.outerHTML}
            </body>
        </html>`;
    }

    public printPage(): void {
        try {
            const myWindow = window.open('', 'PRINT', '');

            myWindow.document.write(this.htmlBuilded);

            myWindow.document.close(); // necessary for IE >= 10
        } catch (e) {
            console.error("Error printing page", e);
        }
    }

    convertCanvasToImage(canvas) {
        return canvas.toDataURL("image/png");
    }
}
